/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SuccessionManagementTalentPoolsTalentPoolLightModel } from './succession-management-talent-pools-talent-pool-light-model';
import { SuccessionManagementTalentRecommendationsTalentRecommendationApprovalModel } from './succession-management-talent-recommendations-talent-recommendation-approval-model';
import { EmployeesEmployeesEmployeeModel } from './employees-employees-employee-model';

export interface SuccessionManagementTalentRecommendationsTalentRecommendationModel {
  id: string;
  employeeId: string;
  talentPoolId: string;
  recommendationState: SuccessionManagementTalentRecommendationsTalentRecommendationModelRecommendationStateEnum;
  reasonForRecommendation: string | null;
  careerAspirations?: string | null;
  approvals: Array<SuccessionManagementTalentRecommendationsTalentRecommendationApprovalModel> | null;
  state: SuccessionManagementTalentRecommendationsTalentRecommendationModelStateEnum;
  createdById: string;
  createdAt: string;
  updatedById: string;
  updatedAt: string;
  talentPool?: SuccessionManagementTalentPoolsTalentPoolLightModel;
  createdBy?: EmployeesEmployeesEmployeeModel;
  updatedBy?: EmployeesEmployeesEmployeeModel;
  isWildcardCandidate?: boolean;
  recommendationReviewNotes?: string | null;
}
export enum SuccessionManagementTalentRecommendationsTalentRecommendationModelRecommendationStateEnum {
  Recommended = 'Recommended',
  ReviewerAccepted = 'ReviewerAccepted',
  ReviewerDeclined = 'ReviewerDeclined',
  Approved = 'Approved',
  Declined = 'Declined'
}
export enum SuccessionManagementTalentRecommendationsTalentRecommendationModelStateEnum {
  Open = 'Open',
  Pending = 'Pending',
  Approved = 'Approved',
  Rejected = 'Rejected'
}
